var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 11.4032C18.2831 10.5779 17.1903 9.36589 14.9444 9.41746C14.9444 9.41746 13.1632 9.3401 11.1497 9.3401C9.13626 9.3401 8.19363 9.38725 6.58066 9.41746C5.5481 9.39167 3.58622 9.62378 2.68273 11.7642C2.08901 13.5693 2.06319 17.3602 2.42459 19.2685C2.50204 20.2485 3.01831 21.6154 4.61879 22.3374C5.59973 22.8532 7.17439 22.6468 8.36185 22.75M6.29672 8.51487C6.24508 6.06498 6.14182 4.13086 8.98138 2.53199C9.9365 2.14517 11.3563 1.80992 13.1117 2.63515C14.9444 3.74404 15.1727 4.91758 15.3317 5.21397C15.7705 6.37445 15.5382 8.02489 15.5898 8.69539",
    stroke: "#5EEAD4",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1094 20.4143C16.1094 21.6973 15.0689 22.7145 13.7944 22.7145C12.52 22.7145 11.4688 21.6973 11.4688 20.4143C11.4688 19.1314 12.52 18.1006 13.7944 18.1006C15.0689 18.1006 16.1094 19.1314 16.1094 20.4143Z",
    stroke: "#5EEAD4",
    strokeWidth: 1.6875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8223 18.4094L17.875 16.406M17.875 16.406L19.3299 15.006C19.6637 14.7217 20.334 14.0558 21.1311 14.8186L22.809 16.406M17.875 16.406L19.5348 17.9997",
    stroke: "#5EEAD4",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockKey);
export default __webpack_public_path__ + "static/media/lock-key.7e2fc1e3e75c8b5c60caa2ffb5225b52.svg";
export { ForwardRef as ReactComponent };